import { h, Fragment } from "preact";
import {
  PageHeader,
  Switch,
  Badge,
  Avatar,
  Typography,
  Button,
  SunOutlined,
  MoonOutlined,
} from "antd";
import { UserOutlined, QuestionCircleOutlined, MenuOutlined } from "@ant-design/icons";
import { getPageParams } from "./HeaderUtils";
import { useContext, useEffect, useState } from "preact/hooks";
import { KeycloakContext } from "../../providers/KeycloakContext";
import useProfile from '../../pages/Account/useProfile'

export default function Header({ onMenuToggle }) {
  const { title, onBack } = getPageParams();
  const { keycloakClient } = useContext(KeycloakContext);
  const {options, person, teammates} = useProfile();
  const [fullName, setFullName] = useState("");

  useEffect(()=>{
    let first_name = person?.firstName ?? " ";
    let last_name = person?.lastName ?? " ";
    setFullName(first_name + " " + last_name);
  }, [person]);

  let userRole = null;
  for (const role of keycloakClient.realmAccess.roles) {
    if (options.some((option) => option.value === role)) {
      userRole = role;
      break;
    }
  }

  const nameStyle = {
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px" /* 160% */,
    letterSpacing: "-0.3px",
    color: "#0F0C2B",
    marginBottom: "-6px",
  };
  const roleStyle = {
    color: "#B6BFDA",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px" /* 240% */,
    letterSpacing: "-0.2px",
    marginBottom: "0px",
  };
  return (
    <>
      <PageHeader
        title={
          <span title={title} style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            <Button
              type="text"
              className="mobile-menu-btn"
              icon={<MenuOutlined />}
              onClick={onMenuToggle}
            />
            {title}
          </span>
        }
        onBack={onBack}
        extra={[
          <div
            style={{ display: "flex", columnGap: "32px", alignItems: "center" }}
          >
            {process.env.REACT_APP_SUPPORT_PORTAL_ENABLED === "true" && (
              <a href="/support-portal/sso" target="_blank" style={{ color: "#0F0C2B", display: "flex", alignItems: "center", marginRight: "-20px" }}>
                <QuestionCircleOutlined style={{ fontSize: "22px" }} />
              </a>
            )}
            {/* <Switch
              checkedChildren={"🌝"}
              unCheckedChildren={"🌙"}
              onChange={(checked) => {}}
              style={{ backgroundColor: "#B6BFDA" }}
            />
            <Badge
              count={1}
              style={{ marginLeft: "16px", backgroundColor: "#3C8DFC" }}
            >
              <BellOutlined
                style={{
                  fontSize: "24px",
                  color: "#0F0C2B",
                  cursor: "pointer",
                }}
              />
            </Badge> */}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Avatar
                icon={<UserOutlined />}
                style={{ marginRight: "8px", backgroundColor: "#B6BFDA" }}
              />
              <div
                className="header-user-info"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingTop: "6px",
                }}
              >
                <h4 id="user-name" style={{ ...nameStyle, minHeight: "24px" }}>{fullName}</h4>
                <p id="user-role" style={roleStyle}>{userRole}</p>
              </div>
            </div>
          </div>,
        ]}
      />
    </>
  );
}
